/* jshint esversion: 6 */

class Shopfront {

    constructor(opts) {
        this.userStatusUrl = opts.userStatusURL;
        // This class sets up everything regardless of what pages the user lands on.
        // But on some screens we want to bypass the modal and
        // dont need the initialisation of other features that dont exist on the page
        // So minimalVersion is just a way around it to only trigger a minimum version
        // of the initialization
        this.minimalVersion = opts.minimalVersion || false;
        // will exist its on the <html> element
        this.rootElement = document.getElementsByClassName('shopfront')[0];
        const targetTime = new Date().getTime() + 20000;

        document.addEventListener('DOMContentLoaded', () => {

            if (!this.minimalVersion) {
                const idleInterval = setInterval(() => {
                    this._modal(this.rootElement, idleInterval, targetTime);
                }, 1000);
                this._tabs();
                this._cardViewMore();
                this._calcContainerWidth('.card.active', '.product-container');
                this._togglePassword();
                this._progressBarStats();
                this._toggleButtonState();
                this._toggleDeliveryAddress();
                this._alertInteractivity();
                this._newslettersAndTopics('.newsletters-types');
                this._newslettersAndTopics('.topics-types');
            }

            this._userStatus();
            this._updateLoginHref();
            this._termsViewMore();

        });
    }

    _toggleClassName(selector, classToBeRemoved, classToBeAdded) {
        if (selector !== undefined) {
            if (selector.classList.contains(classToBeRemoved)) {
                selector.classList.remove(classToBeRemoved);
            }

            if (!selector.classList.contains(classToBeAdded)) {
                selector.classList.add(classToBeAdded);
            }
            else if (selector.classList.contains(classToBeAdded)) {
                selector.classList.remove(classToBeAdded);
                selector.classList.add(classToBeRemoved);
            }
        }
    }

    _clickEvent(selector, targetSelector, classToBeRemoved, classToBeAdded, cb) {
        selector.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            this._toggleClassName(targetSelector, classToBeRemoved, classToBeAdded);

            if (cb !== undefined) {
                cb();
            }
        });
    }

    _onStateChange(path, width, currentStateSelector) {
        const regex = `/${path}/`,
            pathName = window.location.pathname;

        if (pathName.match(regex)) {
            currentStateSelector.style.width = (width * 100) + '%';

            if (path === 'payment') {
                localStorage.removeItem('autocompleteStatus');
            }
        }
    }

    _httpPost(url, data) {
        return fetch(url, data).then(res => res.json());
    }

    _alertInteractivity() {
        const alerts = this.rootElement.querySelectorAll('[data-alert]');

        for (let alert of alerts) {
            const buttonClose = alert.querySelector('.close');
            this._clickEvent(buttonClose, alert, 'show', 'hide');
        }
    }

    _toggleTabs(tabsArray, className, cb) {
        for (let i = 0; i < tabsArray.length; i++) {
            tabsArray[i].addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const tabName = tabsArray[i].getAttribute('data-tab-name');

                let counter = 0;

                self.location = `#${tabName.toLowerCase().split(/\s/).join('-')}`;

                while (counter < tabsArray.length) {
                    tabsArray[counter++].classList.remove(className);
                }

                tabsArray[i].classList.add(className);

                cb(tabName);
            });
        }
    }

    _tabs() {
        const tabs = this.rootElement.querySelector('.tabs'),
            cards = this.rootElement.getElementsByClassName('card');

        const callback = (tabName) => {
            for (let i = 0; i < cards.length; i++) {
                const cardsAttr = cards[i].getAttribute('data-tab-content');

                if (tabName) {
                    (tabName === cardsAttr) ? cards[i].classList.add('active') : cards[i].classList.remove('active');
                    this._calcContainerWidth('.card.active', '.product-container');
                }

                else {
                    cards[i].classList.add('active');
                }
            }
        };

        if (tabs) {
            const tabsContainer = tabs.querySelector('.tabs-container'),
                tabItems = tabs.getElementsByClassName('tab-item'),
                tabsUrl = window.location.hash.split('#')[1];

            if (tabsContainer) {
                if (!tabsUrl) {
                    tabItems[0].classList.add('selected');
                    callback(tabItems[0].getAttribute('data-tab-name'));
                }

                for (let tabItem of tabItems) {
                    const tabAttrSlug = tabItem.getAttribute('data-tab-name').toLowerCase().split(/\s/).join('-');

                    if (tabsUrl === tabAttrSlug) {
                        tabItem.classList.add('selected');
                        callback(tabItem.getAttribute('data-tab-name'));
                    }
                }

                this._toggleTabs(tabItems, 'selected', callback);
            }

            else {
                callback();
            }
        }
    }

    _calcContainerWidth(childrenSelector, targetSelector) {
        const target = this.rootElement.querySelector(targetSelector);

        if (target) {
            const children = target.querySelectorAll(childrenSelector);

            if (children.length) {
                const totalItemWidth = Math.round(children[0].offsetWidth * children.length),
                    padding = (children.length - 1) * 20;

                if (window.screen.width >= 968) {
                    target.style.width = (!targetSelector.includes('tab')) ?
                        children ? (totalItemWidth + padding) + 'px' : '' : (totalItemWidth - 2) + 'px';
                }

                else if (767 <= window.screen.width <= 967) {
                    target.style.width = (!targetSelector.includes('tab')) ?
                        children ? ((children[0].offsetWidth * 2) + padding) + 'px' : '' : (totalItemWidth - 2) + 'px';
                }

                else if (window.screen.width < 767) {
                    target.style.width = (!targetSelector.includes('tab')) ?
                        children ? children[0].offsetWidth + 'px' : '' : totalItemWidth + 'px';
                }
            }
        }
    }

    _modal(rootElement, idleInterval, targetTime) {
        const modal = rootElement.getElementsByClassName('modal')[0];

        let currTime = new Date().getTime(),
            modalExist = false;

        if (modal) {
            const buttonClose = modal.getElementsByClassName('close')[0];

            if (modalExist === false) {
                const mousePos = (event) => {
                    event = event || window.event;
                    const target = event.relatedTarget;
                    if ((!target || target.nodeName == 'HTML') && event.clientY <= 100) {
                        this._toggleClassName(modal, 'out', 'in');
                        this._clickEvent(buttonClose, modal, 'in', 'out');
                        clearInterval(idleInterval);
                        modalExist = true;
                    }
                };

                if (currTime < targetTime) {
                    document.addEventListener('mouseout', mousePos);

                    setTimeout(() => {
                        document.removeEventListener('mouseout', mousePos);
                    }, 1000);
                }

                else {
                    document.removeEventListener('mouseout', mousePos);
                    this._toggleClassName(modal, 'out', 'in');
                    this._clickEvent(buttonClose, modal, 'in', 'out');
                    clearInterval(idleInterval);
                    modalExist = true;
                }
            }
        }
    }

    _togglePassword() {
        const form = this.rootElement.getElementsByTagName('form')[0];

        if (form) {
            const visibleBtn = form.getElementsByClassName('password-visibility')[0],
                input = form.querySelectorAll('.form-section-password input')[0];

            if (visibleBtn) {
                this._clickEvent(visibleBtn, input, 'visible-off', 'visible', () => {
                    const mdIcons = visibleBtn.getElementsByClassName('material-icons')[0];
                    input.type = (input.type === 'password') ? 'text' : 'password';
                    mdIcons.textContent = input.classList.contains('visible-off') ? 'visibility' : 'visibility_off';
                });
            }

        }
    }

    _progressBarStats() {
        const progressBar = this.rootElement.getElementsByClassName('progress-bar-wrapper')[0];

        if (progressBar) {
            const currentState = progressBar.getElementsByClassName('current-status')[0];
            this._onStateChange('account', 1 / 3, currentState);
            this._onStateChange('payment', 2 / 3, currentState);
            this._onStateChange('welcome', 3 / 3, currentState);
        }
    }

    _cardViewMore() {
        const cards = this.rootElement.getElementsByClassName('card');

        for (let i = 0; i < cards.length; i++) {
            const viewMore = cards[i].getElementsByClassName('view-more')[0],
                cardHeader = cards[i].getElementsByClassName('card-header')[0],
                cardBody = cards[i].getElementsByClassName('card-body')[0],
                cardFooter = cards[i].getElementsByClassName('card-footer')[0];

            if (viewMore) {
                this._clickEvent(viewMore, cardBody, 'slide-up', 'slide-down', () => {
                    const mdIcons = viewMore.getElementsByClassName('material-icons')[0];

                    cardHeader.classList.toggle('body-show');
                    this._toggleClassName(cardFooter, 'slide-up', 'slide-down');
                    mdIcons.textContent = cardBody.classList.contains('slide-down') ? 'expand_less' : 'expand_more';
                });
            }
        }
    }

    _termsViewMore() {
        const termsSection = this.rootElement.getElementsByClassName('terms-and-conditions')[0];

        if (termsSection) {
            const viewMore = termsSection.querySelectorAll('.terms-and-conditions p')[0],
                descr = termsSection.getElementsByClassName('description')[0];

            this._clickEvent(viewMore, descr, 'slide-up', 'slide-down', () => {
                const mdIcons = viewMore.getElementsByClassName('material-icons')[0];
                mdIcons.textContent = descr.classList.contains('slide-down') ? 'expand_less' : 'expand_more';
            });
        }
    }

    _isInputFieldNotEmpty(inputFieldArray) {
        return inputFieldArray.value !== '';
    }

    _toggleButtonState() {
        const form = this.rootElement.querySelector('form');

        if (form) {
            const allInputs = form.querySelectorAll('input:not(.hide):not([type="submit"]):not([type="hidden"])'),
                checkbox = form.querySelectorAll('input[name="agree_terms"]')[0],
                submitBtn = form.getElementsByClassName('submit')[0],
                loadingIcon = this.rootElement.querySelector('.loading-wrapper');

            if (checkbox) {
                for (let i of allInputs) {
                    i.addEventListener('change', (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        submitBtn.disabled = !(Array.from(allInputs).every(this._isInputFieldNotEmpty) && checkbox.checked);

                        if (!submitBtn.disabled) {
                            const formNotChargify = form.id !== 'chargify-form';

                            if (formNotChargify) {
                                form.onsubmit = (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    // If recaptcha to be checked then execute recaptcha
                                    if (form.querySelector('#g-recaptcha')) {
                                        grecaptcha.execute();
                                    } else {
                                        // Submit the form normally
                                        this._toggleClassName(loadingIcon, 'hide', 'show');
                                        form.submit();
                                    }
                                };
                            }

                        }
                    });
                }
            }
        }
    }

    _userStatus() {
        const header = this.rootElement.querySelector('header'),
            nonAuthUser = header.querySelector('.non-authenticated-user'),
            authUser = header.querySelector('.authenticated-user');

        if (nonAuthUser && authUser) {
            fetch(this.userStatusUrl).then(resp => resp.json()).then((user) => {
                if (user.authenticated) {
                    const profileDropDown = header.querySelector('.profile-drop-down');

                    this._toggleClassName(authUser, 'hide', 'show');
                    authUser.querySelector('p').textContent = `${user.first_name} ${user.last_name}`;
                    authUser.querySelector('img').src = decodeURIComponent(user.encoded_avatar_url);
                    authUser.querySelector('span i').textContent = 'arrow_drop_down';

                    // toggle dropdown
                    this._clickEvent(authUser, profileDropDown, 'slide-up', 'slide-down');

                    // hide dropdown if user clicks away from dropdown
                    document.addEventListener("click", (e) => {
                        if (profileDropDown.classList.contains("slide-down")) {
                            this._toggleClassName(profileDropDown, 'slide-down', 'slide-up');
                        }
                    }, false);
                }
                else {
                    this._toggleClassName(nonAuthUser, 'hide', 'show');
                }
            });
        }
    }

    _updateLoginHref() {
        const header = this.rootElement.querySelector('header'),
            loginButton = header.querySelector('.non-authenticated-user .button'),
            breachUrl = Cookies.get('breach_url');

        if (loginButton && typeof(breachUrl) !== 'undefined') {
            const loginUrl = new URL(window.location.origin + loginButton.getAttribute('href'));
            let queryParams = loginUrl.searchParams,
                nextUrl = new URL(breachUrl);

            queryParams.set('next', nextUrl.pathname);
            loginButton.setAttribute(
                'href', decodeURIComponent(loginUrl.pathname + '?' + queryParams.toString())
            );
        }
    }

    _toggleDeliveryAddress() {
        const formId = this.rootElement.querySelector('#registrationForm');

        if (formId) {
            const toggleDelAdd = formId.querySelectorAll('.toggle-delivery-address'),
                deliveryAddressSection = formId.querySelector('.form-section-delivery-address'),
                autoCompleteSection = formId.querySelectorAll('.form-section-autocomplete, #autocomplete'),
                autocompleteState = localStorage.getItem('autocompleteStatus');

            if (toggleDelAdd.length > 0) {
                // Sets value when user selects a subscription on shopfront where the home delivery option is included.
                toggleDelAdd[0].textContent = 'Can\'t find your address?';
            }

            const toggleAutocomplete = () => {
                for (let i of autoCompleteSection) {
                    if (i.classList.contains('hide')) {
                        this._toggleClassName(i, 'hide', 'show');
                    }
                    else {
                        this._toggleClassName(i, 'show', 'hide');
                        if (i.id === 'autocomplete') {
                            i.value = '';
                        }
                    }
                }
                
                if (deliveryAddressSection.classList.contains('show')) {
                    this._toggleClassName(deliveryAddressSection, 'hide', 'show');
                    localStorage.setItem('autocompleteStatus', JSON.stringify({
                        'autocomplete': 'show'
                    }));
                }

                else {
                    this._toggleClassName(deliveryAddressSection, 'show', 'hide');
                    localStorage.setItem('autocompleteStatus', JSON.stringify({
                        'autocomplete': 'hide'
                    }));
                }

                this._toggleButtonState();
            };

            const setFieldOnloaded = () => {
                const autocompleteObj = JSON.parse(autocompleteState);

                switch (autocompleteObj.autocomplete) {
                    case 'hide':
                        this._toggleClassName(deliveryAddressSection, 'hide', 'show');
                        this._toggleClassName(autoCompleteSection[0], 'show', 'hide');
                        this._toggleClassName(autoCompleteSection[1], 'show', 'hide');
                        break;

                    case 'show':
                        this._toggleClassName(deliveryAddressSection, 'show', 'hide');
                        this._toggleClassName(autoCompleteSection[0], 'hide', 'show');
                        this._toggleClassName(autoCompleteSection[1], 'hide', 'show');
                        break;
                }

                this._toggleButtonState();
            };

            if (toggleDelAdd.length) {
                if (autocompleteState !== null) {
                    setFieldOnloaded();
                }

                else {
                    localStorage.setItem('autocompleteStatus', JSON.stringify({
                        'autocomplete': 'show'
                    }));

                    deliveryAddressSection.classList.add('hide');
                    autoCompleteSection[0].classList.add('show');
                }

                for (let i of toggleDelAdd) {
                    i.addEventListener('click', toggleAutocomplete);
                }
            }
        }
    }

    _newslettersAndTopics(selector) {
        const elements = this.rootElement.querySelectorAll(selector);

        for (let element of elements) {
            const newsletterCards = element.querySelectorAll('.card'),
                postData = {
                    method: 'POST',
                    cache: 'no-cache'
                };

            for (let i of newsletterCards) {
                i.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    const cardHeader = i.querySelector('.card-header'),
                        checkbox = i.querySelector('input[type="checkbox"]'),
                        unsubUrl = checkbox.getAttribute('data-unsubscribe-url'),
                        subsUrl = checkbox.getAttribute('data-subscribe-url');

                    checkbox.checked = !checkbox.checked;
                    cardHeader.classList.toggle('selected-border');


                    if (selector.includes('topics')) {
                        const tagName = i.querySelector('.call-to-action span');
                        postData.body = `{"tag": "${tagName.textContent}"}`;
                    }

                    (checkbox.checked) ? this._httpPost(subsUrl, postData) : this._httpPost(unsubUrl, postData);
                });

            }
        }

    }

    recaptchaCallback(token) {
        if (token !== null) {
            const form = document.querySelector('form');
            const recaptchaToken = form.querySelector('#recaptchaToken');
            const loadingIcon = this.rootElement.querySelector('.loading-wrapper');

            if (recaptchaToken !== null) {
                recaptchaToken.value = token;
                this._toggleClassName(loadingIcon, 'hide', 'show');
                form.submit();
            }
        }
        // reset recaptcha if form is not submitted
        grecaptcha.reset();
    }
}
